import styled from 'styled-components';

export const Container = styled.ul`
  list-style: none;

  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.xlg};
  }
`;
